import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import tsLogo from "../../assets/images/TS-Logo.png";
import { Tab, Tabs } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const RegisterLicense = () => {
  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("TS_GEN_TOKEN");

  const navigate = useNavigate();

  const [licenseKey, setLicenseKey] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {}, [RegisterLicense]);

  const userRegister = (e) => {
    e.preventDefault();
    setButtonLoader(true);

    let isValidate = validate();
    if (isValidate) {
      axios({
        method: "POST",
        url: `${baseUrl}/user/register-through-license`,
        headers: {
          Authorization: token,
        },
        data: {
          license: licenseKey,
        },
      })
        .then((res) => {
          toast.success("Registered Successfully", {
            position: "bottom-center",
          });
          navigate("/");
          setButtonLoader(false);
        })
        .catch((error) => {
          console.log(error);

          if (error.response !== undefined) {
            toast.remove();
            toast.error(error.response.data.message, {
              position: "bottom-center",
            });
          } else {
            toast.remove();
            toast.error("Something went wrong", {
              position: "bottom-center",
            });
          }
          setButtonLoader(false);
        });
    }
  };

  // validate - function
  const validate = () => {
    if (licenseKey.length === 0) {
      setButtonLoader(false);
      toast.remove();
      toast.error("Licence Key cannot be empty", {
        position: "bottom-center",
      });
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <div>
        <Toaster />
      </div>
      <div className="pattern">
        <span className="red"></span>
        <span className="indigo"></span>
        <span className="blue"></span>
        <span className="green"></span>
        <span className="orange"></span>
      </div>
      <div className="auth-main particles_js" style={{ height: "0%" }}>
        <div className="auth_div vivify popIn register_div">
          <div className="auth_brand">
            <Link className="navbar-brand" to="/">
              <img
                src={tsLogo}
                width="80"
                height="80"
                className="d-inline-block align-top mr-2"
                alt="Ts logo"
              />
            </Link>
          </div>
          <div className="card">
            <div className="body">
              <p className="lead">Create an account</p>
              <div className="form-group mt-4" style={{ textAlign: "left" }}>
                <label className="form-label" htmlFor="companyname">
                  Enter your licence key
                </label>
                <div className="form-control-wrap">
                  <textarea
                    rows={8}
                    id="companyname"
                    placeholder="licence key"
                    className="form-control-lg form-control text-info mb-2"
                    style={{ resize: "none" }}
                    value={licenseKey}
                    onChange={(e) => {
                      setLicenseKey(e.target.value);
                    }}
                  />
                </div>
              </div>
              <Button
                loading={buttonLoader}
                type="submit"
                className="btn btn-primary btn-round px-5 my-4"
                onClick={(e) => userRegister(e)}
              >
                REGISTER
              </Button>
              <div className="bottom my-n2">
                <span>
                  Already have an account? <Link to="/">Login</Link>
                </span>
              </div>{" "}
            </div>
          </div>
        </div>
        <div id="particles-js"></div>
      </div>
    </>
  );
};

export default RegisterLicense;
